import { useState, useEffect } from 'react';
import { WorkflowDefinition } from 'src/@types/selfServeTypes/workflowDefinition.interface';
import { checkWorkflowPermissions } from 'src/components/commonComponents/WorkflowTable/workflowPermissionUtils';
import { logger } from 'src/utils/logger';

import { VIEW_FILTER, ViewFilterType } from './ManageWorkflowConstants';

export function useManageWorkflowPermissions(
	allWorkflows: WorkflowDefinition[],
	viewFilter: ViewFilterType,
	userName: string | undefined
) {
	const [editableWorkflows, setEditableWorkflows] = useState<WorkflowDefinition[]>([]);
	const [isCheckingPermissions, setIsCheckingPermissions] = useState(true);
	const [permissionError, setPermissionError] = useState<string | null>(null);

	useEffect(() => {
		async function checkPermissions() {
			if (userName && allWorkflows.length > 0) {
				setIsCheckingPermissions(true);
				setPermissionError(null);
				
				try {
					const workflowIds = allWorkflows.map((w) => w.workflowId);
					const authorizedIds = await checkWorkflowPermissions(
						workflowIds,
						userName,
						'edit'
					);

					const filtered = allWorkflows.filter((workflow) =>
						authorizedIds.includes(workflow.workflowId)
					);

					setEditableWorkflows(filtered);
				} catch (error) {
					logger.error(`Failed to check workflow permissions [ userName : error ] ::: [ ${userName} : ${JSON.stringify(error)} ]`);
					setPermissionError('Failed to check workflow permissions. Please reload the page to try again.');
					setEditableWorkflows([]);
				} finally {
					setIsCheckingPermissions(false);
				}
			} else if (!userName || allWorkflows.length === 0) {
				setIsCheckingPermissions(false);
			}
		}

		checkPermissions();
	}, [userName, allWorkflows]);

	return { editableWorkflows, isCheckingPermissions, permissionError };
}
